module.exports = __webpack_public_path__ + "static/jalyna-2c94cf6157fd40a1da61d2b39cce3221.jpg";